module.exports = __webpack_public_path__ + "static/img/rz.d9fe959.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/user/rz.png
// module id = VjG4
// module chunks = 1